import { ModuleManager, SectionList } from "@module-system";
import CommonConditions from "@lib/commonConditions";
import component from "./Components/AgentOnHoldEvent.vue";
import locales from "./locales";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "YkbAgentOnHoldEvent",
  version: "1.0.0",
  register() {
    if(CommonConditions.isAgent()){
      window.CONFIG.CALL_BUTTONS.REMOTE_AUDIO_MUTE.ENABLED = false;
      window.CONFIG.CALL_BUTTONS.REMOTE_VIDEO_MUTE.ENABLED = false;
      window.CONFIG.CALL_BUTTONS.HANGUP.ENABLED = false;
      window.CONFIG.HOLD_STYLE = "top-sheet";
    }

    ModuleManager.addLocales(locales, "YkbAgentOnHoldEvent");

    ModuleManager.addViewModule({
      key: "AgentOnHoldEvent",
      section: SectionList.AbsoulteBottom,
      ViewComponent: component,
      Condition: (rtcId) => {
        return CommonConditions.isAgent(rtcId);
      }
    });
  },
};
export default module;